import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ScwsService } from './scws-service.service';
import { SignatureSessionService } from './signature-session.service';
import { Router } from '@angular/router';
import { SpinnerService } from '../../shared/services/spinner.service';
import { ShowOrHideSpinner } from '../../shared/models/showOrHideSpinner';

@Injectable()
export class PinValidatorService extends ShowOrHideSpinner {
  public isBreak = false;
  public numberChance = 3;
  public INCORRECT;
  public CORRECT;
  public SUCCESS;
  public ERROR;
  public REMOVE;

  constructor(private toastr: ToastrService,
    private scwsService: ScwsService,
    private signatureSession: SignatureSessionService,
    private router: Router,
    private spinnerService: SpinnerService) {
    super();
  }

  public isValid() {
    this.showSpinner(this.spinnerService);
    const value = (document.getElementById('codepin') as HTMLInputElement).value;
    this.scwsService
      .getPrivateKeys(this.signatureSession.scwsCert, value)
      .subscribe(pkeys => {
        this.signatureSession.scwsPkey = pkeys;
        this.toastr.success(this.CORRECT, this.SUCCESS);
        this.router.navigate(['/signer/resultat']);
      }, (err) => {
        console.log(err);
        if (err.code === 'CKR_TOKEN_NOT_PRESENT') {
          this.hideSpinner(this.spinnerService);
          this.setPin();
          this.toastr.error(this.REMOVE, this.ERROR);
        } else {
          this.hideSpinner(this.spinnerService);
          this.setPin();
          this.toastr.error(this.INCORRECT, this.ERROR);
          this.numberChance = this.numberChance - 1;
          if (this.numberChance === 0) {
            this.isBreak = true;
          }
        }
      });
  }

  public setPin() {
    if (this.signatureSession.scwsCert) {
      const cardpin = this.scwsService.getCardPin(this.signatureSession.scwsCert);
      this.signatureSession.pin.blocked = cardpin.blocked;
      this.signatureSession.pin.lastTry = cardpin.lastTry;
      this.signatureSession.pin.remainingTries = cardpin.remainingTries;
    }
  }
}
